function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

(function (window, document, $) {
  "use strict";

  var remote_get = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(endpoint) {
      var data,
          options,
          url,
          _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              url = [unlimited_get_api_url("v1"), endpoint].join("/");
              return _context.abrupt("return", new Promise(function (success, reject) {
                $.ajax(_objectSpread({
                  url: url,
                  data: data,
                  success: success,
                  dataType: "json",
                  type: "GET",
                  contentType: "application/json; charset=utf-8"
                }, options));
              }));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function remote_get(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var get_remote_cities = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve) {
                  var cities;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return remote_get("cities");

                        case 2:
                          cities = _context2.sent;

                          if (cities) {
                            _context2.next = 5;
                            break;
                          }

                          return _context2.abrupt("return", reject("No Cities were found"));

                        case 5:
                          resolve(cities);

                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function get_remote_cities() {
      return _ref2.apply(this, arguments);
    };
  }();

  var get_remote_streets = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(city) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(resolve, reject) {
                  var streets;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return remote_get("streets", {
                            city: city
                          });

                        case 2:
                          streets = _context4.sent;

                          if (streets) {
                            _context4.next = 5;
                            break;
                          }

                          return _context4.abrupt("return", reject("No streets were found for this city id: ".concat(city)));

                        case 5:
                          resolve(streets);

                        case 6:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x4, _x5) {
                  return _ref5.apply(this, arguments);
                };
              }()));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function get_remote_streets(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var get_remote_houses = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(city, street) {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(resolve, reject) {
                  var houses;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.next = 2;
                          return remote_get("houses", {
                            city: city,
                            street: street
                          });

                        case 2:
                          houses = _context6.sent;

                          if (houses) {
                            _context6.next = 5;
                            break;
                          }

                          return _context6.abrupt("return", reject("No houses were found city: ".concat(city, " and street: ").concat(street)));

                        case 5:
                          resolve(houses);

                        case 6:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));

                return function (_x8, _x9) {
                  return _ref7.apply(this, arguments);
                };
              }()));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function get_remote_houses(_x6, _x7) {
      return _ref6.apply(this, arguments);
    };
  }();

  var get_typeahead = function get_typeahead() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var $this = this;

    var _options = _objectSpread({
      items: 20,
      minLength: 2,
      autoSelect: true
    }, options);

    return function (source) {
      return $this.typeahead(_objectSpread(_objectSpread({}, _options), {}, {
        source: source
      }));
    };
  };

  var get_generate_values = function get_generate_values(item) {
    var name = item.name,
        have_streets = item.have_streets,
        id = item.id;
    return {
      id: window.parseInt(id),
      name: name.toString().trim(),
      have_streets: have_streets && window.parseInt(have_streets) > 0
    };
  };

  function Input($) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.$ = $;
    this.options = _objectSpread({
      placeholder: this.$.attr("placeholder"),
      loading: "",
      not_found: ""
    }, options);
    var names = [];

    this.set_autocomplete_names = function (autocomplete_response) {
      names = autocomplete_response.map(function (obj) {
        return obj.name;
      });
      return names;
    };

    this.get_autocomplete_names = function () {
      return names;
    };
  }

  Input.prototype.empty = function () {
    return this.$.val("");
  };

  Input.prototype.disable = function () {
    this.empty();
    return this.$.addClass("js-disabled"); //return this.$.attr('disabled', 'true');
  };

  Input.prototype.enable = function () {
    this.reset();
    return this.$.removeClass("js-disabled"); //return this.$.removeAttr('disabled');
  };

  Input.prototype.set_typeahead = function (items) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.enable();
    var set_typeahead = get_typeahead.call(this.$, options);
    return set_typeahead(items);
  };

  Input.prototype.set_value = function (str) {
    return this.$.val(str.toString().trim());
  };

  Input.prototype.get_value = function () {
    return this.$.val().trim();
  };

  Input.prototype.destroy = function () {
    this.disable();
    return this.$.typeahead("destroy");
  };

  Input.prototype.get_active = function () {
    return this.$.typeahead("getActive");
  };

  Input.prototype.set_attr = function (attr, value) {
    return this.$.attr(attr, value);
  };

  Input.prototype.reset = function () {
    return this.set_attr("placeholder", this.options.placeholder);
  };

  Input.prototype.loading = function () {
    return this.set_attr("placeholder", this.options.loading);
  };

  Input.prototype.is_valid_user_input = function (user_input) {
    user_input = user_input || this.get_value();
    return this.get_autocomplete_names().indexOf(user_input) > -1;
  };

  function City_Input() {
    Input.call(this);
  }

  City_Input.prototype = Object.create(Input.prototype);
  City_Input.prototype.constructor = City_Input;

  City_Input.prototype.updater = function () {};

  function GForm_Autocomplete_Validation($form) {
    this.$ = $form;
    this.formId = window.parseInt(this.$.attr("id").split("gform_")[1]); //this.$gfields   = this.$.find('[class^="gfield autocomplete-"]');
    //this.$inputs    = this.$gfields.find('input');

    this.$inputs = this.$.find('.gform_fields [aria-required="true"]'); //this.$gfields   = this.$.find('.gform_fields [aria-required="true"]');

    this.has_empty = 0;
  }

  GForm_Autocomplete_Validation.prototype.reset_form = function () {
    this.has_empty = 0;
    this.$inputs.attr("aria-invalid", "false");
    var $gfield_error = this.$.find(".gfield_error");

    if ($gfield_error.length) {
      $gfield_error.find(".validation_message").remove();
      $gfield_error.removeClass("gfield_error");
    }
  };

  GForm_Autocomplete_Validation.prototype.set_invalid_input = function ($input, validation_message) {
    console.log($input);
    var $this = $input;
    var gfield = $this.closest(".gfield");
    gfield.addClass("gfield_error");
    $("<div class=\"gfield_description validation_message\" aria-live=\"polite\">".concat(validation_message, "</div>")).insertAfter(gfield.find(".ginput_container"));
    $this.attr("aria-invalid", "true");
  };

  GForm_Autocomplete_Validation.prototype.run_validation = function () {
    var that = this;
    that.$inputs.each(function () {
      var $input = $(this);

      if (!$input.val().trim()) {
        var message = "זהו שדה חובה.";

        if (typeof $input.data("error") !== "undefined" && $input.data("error").trim() !== "") {
          message = $input.data("error").trim();
        }

        that.set_invalid_input($input, message);
        that.has_empty++;
      } else if ($input.attr("type").toString() === "email") {
        if (!window.isEmail($input.val())) {
          that.set_invalid_input($input, "נא להזין מייל חוקי.");
          that.has_empty++;
        }
      }
    });
  };

  var forms_XPath = {};
  var forms_hashed_address = {};

  var autocomplete = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(cities) {
      var $form_box, $form, form_id, XPath, get_input, $cities_input, $streets_input, $house_input, streets, houses, get_streets, get_houses, main, listen;
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              $form_box = $(this);
              $form = new GForm_Autocomplete_Validation($form_box.find("form").first());
              form_id = $form.formId;
              XPath = $form_box.find("form").first().getXPath().toString(); //.replace(/\/|\[|\]/gi, '');

              get_input = function get_input(key) {
                return $form_box.find(".autocomplete-".concat(key, " input"));
              };

              $cities_input = new Input(get_input("city"), {
                loading: "טוען ערים..."
              });
              $streets_input = new Input(get_input("street"), {
                loading: "טוען רחובות...",
                not_found: "לא נמצאו רחובות"
              });
              $house_input = new Input(get_input("house"), {
                loading: "טוען...",
                not_found: "0"
              });
              $streets_input.disable();
              $house_input.disable();
              streets = {};
              houses = {};

              get_streets = /*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(city_id) {
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          return _context9.abrupt("return", new Promise( /*#__PURE__*/function () {
                            var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(resolve, reject) {
                              var street;
                              return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                                while (1) {
                                  switch (_context8.prev = _context8.next) {
                                    case 0:
                                      if (!streets.hasOwnProperty(city_id)) {
                                        _context8.next = 2;
                                        break;
                                      }

                                      return _context8.abrupt("return", resolve(streets[city_id]));

                                    case 2:
                                      _context8.prev = 2;
                                      _context8.next = 5;
                                      return get_remote_streets(city_id);

                                    case 5:
                                      street = _context8.sent;
                                      streets[city_id] = street;
                                      resolve(street);
                                      _context8.next = 13;
                                      break;

                                    case 10:
                                      _context8.prev = 10;
                                      _context8.t0 = _context8["catch"](2);
                                      reject(_context8.t0);

                                    case 13:
                                    case "end":
                                      return _context8.stop();
                                  }
                                }
                              }, _callee8, null, [[2, 10]]);
                            }));

                            return function (_x12, _x13) {
                              return _ref10.apply(this, arguments);
                            };
                          }()));

                        case 1:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }));

                return function get_streets(_x11) {
                  return _ref9.apply(this, arguments);
                };
              }();

              get_houses = /*#__PURE__*/function () {
                var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(city_id, street_id) {
                  var key;
                  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                    while (1) {
                      switch (_context11.prev = _context11.next) {
                        case 0:
                          key = "".concat(city_id.toString()).concat(street_id.toString());
                          return _context11.abrupt("return", new Promise( /*#__PURE__*/function () {
                            var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(resolve, reject) {
                              var house;
                              return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                                while (1) {
                                  switch (_context10.prev = _context10.next) {
                                    case 0:
                                      if (!houses.hasOwnProperty(key)) {
                                        _context10.next = 2;
                                        break;
                                      }

                                      return _context10.abrupt("return", resolve(houses[key]));

                                    case 2:
                                      _context10.prev = 2;
                                      _context10.next = 5;
                                      return get_remote_houses(city_id, street_id);

                                    case 5:
                                      house = _context10.sent;
                                      houses[key] = house;
                                      resolve(house);
                                      _context10.next = 13;
                                      break;

                                    case 10:
                                      _context10.prev = 10;
                                      _context10.t0 = _context10["catch"](2);
                                      reject(_context10.t0);

                                    case 13:
                                    case "end":
                                      return _context10.stop();
                                  }
                                }
                              }, _callee10, null, [[2, 10]]);
                            }));

                            return function (_x16, _x17) {
                              return _ref12.apply(this, arguments);
                            };
                          }()));

                        case 2:
                        case "end":
                          return _context11.stop();
                      }
                    }
                  }, _callee11);
                }));

                return function get_houses(_x14, _x15) {
                  return _ref11.apply(this, arguments);
                };
              }();

              main = function main(item) {
                $streets_input.destroy();
                $house_input.destroy();
                forms_hashed_address[form_id] = "";

                _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
                  var _get_generate_values, have_streets, id, _streets, updater;

                  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                    while (1) {
                      switch (_context13.prev = _context13.next) {
                        case 0:
                          _get_generate_values = get_generate_values(item), have_streets = _get_generate_values.have_streets, id = _get_generate_values.id;
                          console.log("form id", form_id, id);

                          if (form_id == 2) {
                            //address is not from API
                            jQuery("#input_2_9").val(id);
                          }

                          if (!have_streets) {
                            _context13.next = 19;
                            break;
                          }

                          _context13.prev = 4;
                          $streets_input.loading();
                          _context13.next = 8;
                          return get_streets(id);

                        case 8:
                          _streets = _context13.sent;
                          $streets_input.set_autocomplete_names(_streets);

                          updater = function updater() {
                            var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                            _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
                              var current_street, _houses;

                              return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                                while (1) {
                                  switch (_context12.prev = _context12.next) {
                                    case 0:
                                      $house_input.destroy();
                                      current_street = $streets_input.get_active();
                                      _context12.prev = 2;
                                      $house_input.loading();
                                      _context12.next = 6;
                                      return get_houses(id, current_street.id);

                                    case 6:
                                      _houses = _context12.sent;
                                      $house_input.set_autocomplete_names(_houses);
                                      $house_input.set_typeahead(_houses, {
                                        minLength: 1,
                                        // selectOnBlur: false,
                                        updater: function updater(house) {
                                          // ;(async () => {
                                          forms_hashed_address[form_id] = house["hashed_address"];
                                          return house; //  })();
                                        }
                                      });
                                      _context12.next = 14;
                                      break;

                                    case 11:
                                      _context12.prev = 11;
                                      _context12.t0 = _context12["catch"](2);
                                      console.error(_context12.t0);

                                    case 14:
                                    case "end":
                                      return _context12.stop();
                                  }
                                }
                              }, _callee12, null, [[2, 11]]);
                            }))();

                            return item;
                          };

                          $streets_input.set_typeahead(_streets, {
                            updater: updater,
                            matcher: function matcher(item) {
                              return ~item.name.toLowerCase().indexOf(this.query.toLowerCase().replace("׳", "'"));
                            }
                          });
                          _context13.next = 17;
                          break;

                        case 14:
                          _context13.prev = 14;
                          _context13.t0 = _context13["catch"](4);
                          console.error(_context13.t0);

                        case 17:
                          _context13.next = 22;
                          break;

                        case 19:
                          $streets_input.set_value($streets_input.options.not_found);
                          $house_input.set_value($house_input.options.not_found);
                          forms_hashed_address[form_id] = $cities_input.get_active().id;

                        case 22:
                        case "end":
                          return _context13.stop();
                      }
                    }
                  }, _callee13, null, [[4, 14]]);
                }))();

                return item;
              };

              listen = function listen() {
                $cities_input.$.on("change", function () {
                  $form.reset_form();

                  if (!$cities_input.is_valid_user_input()) {
                    $cities_input.empty();
                    $streets_input.destroy();
                    $house_input.destroy();
                    $form.set_invalid_input($cities_input.$, "חובה לבחור מהרשימה.");
                  }
                }).on("input", function () {
                  window.setTimeout(function () {
                    if ($cities_input.get_value().length <= 1) {
                      $streets_input.destroy();
                      $house_input.destroy();
                    }
                  }, 100);
                });
                $streets_input.$.on("change", function () {
                  $form.reset_form();

                  if (!$streets_input.is_valid_user_input()) {
                    $streets_input.empty();
                    $house_input.destroy();
                    $form.set_invalid_input($streets_input.$, "חובה לבחור מהרשימה.");
                  }
                }).on("input", function () {
                  window.setTimeout(function () {
                    return $streets_input.get_value().length <= 1 && $house_input.destroy();
                  }, 100);
                });
                $house_input.$.on("change", function () {
                  $form.reset_form();

                  if (!$house_input.is_valid_user_input()) {
                    $house_input.empty();
                    $form.set_invalid_input($house_input.$, "חובה לבחור מהרשימה.");
                  }
                });
              };

              try {
                $cities_input.disable();
                $cities_input.loading(); //const cities = await get_remote_cities();

                $cities_input.set_autocomplete_names(cities);
                $cities_input.enable();
                listen();
                $cities_input.set_typeahead(cities, {
                  updater: main
                });
              } catch (err) {
                console.error(err);
              }

            case 17:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    return function autocomplete(_x10) {
      return _ref8.apply(this, arguments);
    };
  }();

  jQuery(document).ready( /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15($) {
      var $form_box, listen, cities;
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              $form_box = $(".form-box");

              listen = function listen(e) {
                var code = e.keyCode || e.which;
                var $gform_wrapper = $(this);
                var is_submit_target = jQuery(e.target).is('input[type="submit"],input[type="button"]');

                if (is_submit_target || code === 13 && !is_submit_target) {
                  var _$form = new GForm_Autocomplete_Validation($gform_wrapper.find("form"));

                  _$form.reset_form();

                  _$form.run_validation();

                  if (_$form.has_empty) {
                    e.preventDefault();
                    return false;
                  }

                  var hashed_address = forms_hashed_address.hasOwnProperty(_$form.formId) && forms_hashed_address[_$form.formId];

                  if (hashed_address) {
                    _$form.$.find(".hashed_address input").val(hashed_address);

                    if (_$form.formId == 1 || _$form.formId == 11) {
                      window.gformAddSpinner(_$form.formId.toString(), unlimited_get_gform_spinner_url());
                      var params = new URLSearchParams(window.location.search);
                      params.delete("hashed_address");
                      var queryParameters = params.toString(); // let queryParameters = window.location.search;
                      // if (queryParameters.charAt(0) === "?") {
                      //   queryParameters = queryParameters.slice(1);
                      // }

                      window.location.href = "".concat(unlimited_get_page_for_address_results_permalink(), "?hashed_address=").concat(hashed_address, "&").concat(queryParameters);
                      e.preventDefault();
                      return false;
                    } else {
                      _$form.$.submit();

                      return true;
                    }
                  } else {
                    _$form.$.submit();

                    return true;
                  }
                }
              };

              $(document).on("keypress click", ".gform_wrapper", listen);
              _context15.next = 5;
              return get_remote_cities();

            case 5:
              cities = _context15.sent;
              $form_box.each(function () {
                autocomplete.call(this, cities);
              });
              $(document).on("gform_post_render", function (event, form_id, current_page) {
                form_id = form_id.toString();
                var $form = $("#gform_".concat(form_id));

                if (form_id == 3
                /* $form.closest('.site-footer__newsletter') */
                ) {
                  //newsletter form
                  var gform_description_HTML = $form.find(".gform_description").detach();
                  $(gform_description_HTML).insertAfter($form.find('[type="submit"]'));
                }

                window.setTimeout(function () {
                  var $confirmation_wrapper = $("#gform_confirmation_wrapper_".concat(form_id));
                  var $parent = $confirmation_wrapper.parent();
                  $parent.find(".form-box__tooltip").hide();
                  $parent.find(".form-box__disclaimer").hide();
                  $parent.find(".form-box__small").hide();
                }, 100);

                if ($("div.validation_error", "#gform_".concat(form_id)).length > 0) {}
              });

            case 8:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function (_x18) {
      return _ref15.apply(this, arguments);
    };
  }());
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    var $accordion = $('.accordion'),
        $collapse = $accordion.find('.collapse');

    var modify = function modify(open) {
      var CLASS_NAME = 'js-accordion-open';
      var $accordion = $(this).closest('.accordion');
      return open ? $accordion.addClass(CLASS_NAME) : $accordion.removeClass(CLASS_NAME);
    }; // The collapsible content is about to be shown.


    $collapse.on('show.bs.collapse', function () {
      modify.call(this, true);
    }); // The collapsible content is now fully shown.

    $collapse.on('shown.bs.collapse', function () {
      var $accordionBody = $(this).find('.accordion-body');
      setTimeout(function () {
        return $accordionBody.focus();
      }, 100);
    }); // The collapsible content is about to be hidden.

    $collapse.on('hide.bs.collapse', function () {
      modify.call(this);
    }); // The collapsible content is now hidden.

    $collapse.on('hidden.bs.collapse', function () {
      var $button = $(this);

      if (!$button.is(':focus')) {
        setTimeout(function () {
          $button.focus();
        }, 100);
      }
    });
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  jQuery(document).ready(function ($) {
    var $body = $('body');
    $body.on('focusin', '.gfield input', function (e) {
      var $this = $(this);
      $this.closest('.gfield').addClass('-pre-focusin');
    });
    $body.on('focusout', '.gfield input', function (e) {
      var $this = $(this);
      var value = $this.val().trim();
      var $parent = $this.closest('.gfield');

      if (value) {
        $parent.addClass('-pre-focusin');
        return;
      }

      $parent.removeClass('-pre-focusin');
    });
    ;

    (function () {
      var $newsletter = $('#newsletter');
      var $form = $newsletter.find('form');
      $form.find('.gform_footer').append($form.find('.gform_description').detach());
    })();

    function checkIfAnalyticsLoaded() {
      if (ga) {
        ga(function () {
          var tracker = ga.getAll()[0];
          var trackingId = tracker.get('trackingId');
          var clientId = tracker.get('clientId');

          if ($('.SF_TrackId, .SF_ClientId')) {
            $('.SF_TrackId input').val(trackingId);
            $('.SF_ClientId input').val(clientId);
          }
        });
      } else {
        setTimeout(checkIfAnalyticsLoaded, 500);
      }
    }

    setTimeout(checkIfAnalyticsLoaded, 500);
  });
})(window, document, jQuery);

jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
  if (form_id == 8) {
    jQuery('.js-signature').jqSignature({
      height: 150,
      border: '1px solid #c4c4c4',
      background: '#f5f5f5',
      autoFit: true,
      lineWidth: 3
    });
    jQuery('.clearCanvas').on('click', function (e) {
      e.preventDefault();
      jQuery('.js-signature').jqSignature('clearCanvas');
      jQuery('.user_signature input').val('');
    });
    jQuery('.js-signature').on('jq.signature.changed', function (a) {
      console.log(a);
      var sig = jQuery('.js-signature').jqSignature('getDataURL');
      jQuery('.user_signature input').val(sig);
    });
  }
});
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function getTop() {
  return jQuery(window).scrollTop();
}

function isIE11() {
  return !!window.MSInputMethodContext && !!document.documentMode;
}

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function scroll_to(element) {
  var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var $element = jQuery(element);
  var $site_navbar = jQuery('#site_navbar');

  if ($element.length) {
    var scrollTop = $element.first().offset().top - ($site_navbar.outerHeight() + window.parseInt(distance));
    jQuery('html, body').animate({
      scrollTop: scrollTop
    }, {
      duration: 1000,
      easing: 'easeInOutExpo'
    });
  }
}

var Comp_Factory = /*#__PURE__*/function () {
  function Comp_Factory($, CLASS_NAME) {
    _classCallCheck(this, Comp_Factory);

    this.$ = $;
    this.CLASS_NAME = CLASS_NAME;
  }

  _createClass(Comp_Factory, [{
    key: "open",
    value: function open() {
      return this.$.addClass(this.CLASS_NAME);
    }
  }, {
    key: "close",
    value: function close() {
      return this.$.removeClass(this.CLASS_NAME);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      return this.$.toggleClass(this.CLASS_NAME);
    }
  }, {
    key: "is_open",
    value: function is_open() {
      return this.$.hasClass(this.CLASS_NAME);
    }
  }]);

  return Comp_Factory;
}();

;

(function (window, document, $) {
  $.fn.doSlickSlide = function (direction) {
    var self = $(this),
        slickSection = self.closest('.slick-section');
    if (slickSection.length > 0) slickSection.find('.slick-slider').slick(direction);
    return this;
  };

  $('.slick-next').on('click', function () {
    $(this).doSlickSlide('slickNext');
  });
  $('.slick-prev').on('click', function () {
    $(this).doSlickSlide('slickPrev');
  });
  $.easing['jswing'] = $.easing['swing'];
  $.extend(jQuery.easing, {
    easeInOutExpo: function easeInOutExpo(x, t, b, c, d) {
      if (t == 0) return b;
      if (t == d) return b + c;
      if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
  });
  /**
   * Creates an XPath from a node (currently not used inside this Class (instead FormHTML.prototype.generateName is used) but will be in future);
   * @param  {string=} rootNodeName	if absent the root is #document
   * @return {string}                 XPath
   */

  $.fn.getXPath = function (rootNodeName) {
    //other nodes may have the same XPath but because this function is used to determine the corresponding input name of a data node, index is not included
    var position,
        $node = this.first(),
        nodeName = $node.prop('nodeName'),
        $sibSameNameAndSelf = $node.siblings(nodeName).addBack(),
        steps = [],
        $parent = $node.parent(),
        parentName = $parent.prop('nodeName');
    position = $sibSameNameAndSelf.length > 1 ? '[' + ($sibSameNameAndSelf.index($node) + 1) + ']' : '';
    steps.push(nodeName + position);

    while ($parent.length === 1 && parentName !== rootNodeName && parentName !== '#document') {
      $sibSameNameAndSelf = $parent.siblings(parentName).addBack();
      position = $sibSameNameAndSelf.length > 1 ? '[' + ($sibSameNameAndSelf.index($parent) + 1) + ']' : '';
      steps.push(parentName + position);
      $parent = $parent.parent();
      parentName = $parent.prop('nodeName');
    }

    return '/' + steps.reverse().join('/');
  };

  $.fn.countTo = function (options) {
    // merge the default plugin settings with the custom options
    options = $.extend({}, $.fn.countTo.defaults, options || {}); // how many times to update the value, and how much to increment the value on each update

    var loops = Math.ceil(options.speed / options.refreshInterval),
        increment = (options.to - options.from) / loops;
    return $(this).each(function () {
      var _this = this;

      var loopCount = 0,
          value = options.from,
          interval = setInterval(updateTimer, options.refreshInterval);

      function updateTimer() {
        value += increment;
        loopCount++;
        $(_this).html(value.toFixed(options.decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ","));

        if (typeof options.onUpdate == 'function') {
          options.onUpdate.call(_this, value);
        }

        if (loopCount >= loops) {
          clearInterval(interval);
          value = options.to;

          if (typeof options.onComplete == 'function') {
            options.onComplete.call(_this, value);
          }
        }
      }
    });
  };

  $.fn.countTo.defaults = {
    from: 0,
    // the number the element should start at
    to: 100,
    // the number the element should end at
    speed: 1000,
    // how long it should take to count between the target numbers
    refreshInterval: 100,
    // how often the element should be updated
    decimals: 0,
    // the number of decimal places to show
    onUpdate: null,
    // callback method for every time the element is updated,
    onComplete: null // callback method for when the element finishes updating

  };
})(window, document, jQuery);
function introduction_details_count() {
  jQuery('.introduction__details-title').each(function () {
    var $this = jQuery(this);
    var to = window.parseInt($this.text().replace(/[^0-9]/g, ''));
    ;

    (function ($this, to, i) {
      window.setTimeout(function () {
        $this.countTo({
          to: to,
          speed: 1000,
          // how long it should take to count between the target numbers
          refreshInterval: 50 // how often the element should be updated

        });
      }, 150);
    })($this, to);
  });
}

;

(function (window, document, $) {
  "use strict";

  var htmlBody = $('html, body');
  ;

  (function () {
    /** Page scroll */
    var $site_navbar = $('#site_navbar');
    $('.scroll-to').on('click', function (e) {
      e.preventDefault();
      var anchor = $(this),
          target = anchor.attr('href'),
          $section = $(target).first();

      if ($section.length > 0) {
        var scrollTop = $section.offset().top - $site_navbar.outerHeight(false);
        htmlBody.stop().animate({
          scrollTop: scrollTop
        }, 1000, 'easeInOutExpo');
      }
    });
  })();

  ;

  (function () {
    $('.form-box__tooltip-button').on('click', function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('active');
    });
    $('.modal').on('show.bs.modal', function () {
      var $this = $(this);
      $this.find('.form-box__tooltip.active').removeClass('active');
    });
    $("#quick_contact").on('show.bs.modal', function () {
      var $this = $(this);
      htmlBody.find('.modal').each(function () {
        if ($this.attr('id') !== $(this).attr('id')) {
          $(this).modal('hide');
        }
      });
    });
    var current_package = 0;
    $('.package .package__foot .button').on('click', function (e) {
      e.preventDefault();

      if ($('body').hasClass('page-template-business-packages')) {
        var $package = $(this).closest('.package');
        var package_id_or_name = $package.data('package');

        if (package_id_or_name) {
          current_package = package_id_or_name;
        }

        $("#package_quick_contact").modal('show');
      } else {
        $('.quick-checking-toggle').trigger('click');
      }
    });
    $("#package_quick_contact").on('show.bs.modal', function () {
      var $this = $(this);
      $this.find('.gform_package input').val(current_package);
    });
    ;

    (function () {
      var management_member = $('.management-member');

      if (management_member.length) {
        var class_name = ".".concat(management_member.get(0).className);
        management_member.find("".concat(class_name, "__toggle")).hover(function () {
          $(this).closest(class_name).addClass('js-in');
        }, function () {
          $(this).closest(class_name).removeClass('js-in');
        });
      }

      $(".directorion-grid__item > a").hover(function () {
        if (!$(this).hasClass('js-hover')) {
          $(this).addClass('js-hover');
        }
      }, function () {
        $(this).removeClass('js-hover');
      });
    })(); // ;( function () {
    //     $('.select-package .tab-pane .button').on('click', function (e) {
    //         e.preventDefault();
    //         window.scroll_to('#be_in_touch', 60 );
    //     });
    // })();

  })();

  ;

  (function () {
    return;
    var quick_contact = {
      $component: $('#quick_contact'),
      form_id: 0,
      $toggle: null,
      $close: null,
      getElement: function getElement(key) {
        return this.$component.find(".quick-contact__".concat(key)).first();
      },
      cssClassKey: 'quick-contact--open',
      toggleTabindex: function toggleTabindex() {
        var elements = this.getElement('form').find('select,textarea,input,[role="button"]');

        if (this.$component.hasClass(this.cssClassKey)) {
          elements.attr('tabindex', '0');
          return;
        }

        elements.attr('tabindex', '-1');
      },
      toggleForm: function toggleForm(e) {
        e && e.preventDefault();
        this.$component.toggleClass(this.cssClassKey);
        this.toggleTabindex();
      },
      closeForm: function closeForm(e) {
        e && e.preventDefault();
        this.$component.removeClass(this.cssClassKey);
        this.toggleTabindex();
      },
      init: function init() {
        // Initial all inputs will be with tabindex -1
        this.toggleTabindex();
        this.$toggle = this.getElement('toggle');
        this.$close = this.getElement('close');
        var temp = this.$component.find('.gform_wrapper').attr('id');
        this.form_id = temp.length && window.parseInt(temp.split('_').slice(-1)[0]);
      }
    };
    quick_contact.init();
    quick_contact.$toggle.on('click', quick_contact.toggleForm.bind(quick_contact));
    quick_contact.$close.on('click', quick_contact.closeForm.bind(quick_contact));
    jQuery(document).on('gform_confirmation_loaded', function (event, form_id) {
      // code to trigger on form or form page render
      if (quick_contact.form_id === window.parseInt(form_id)) {
        var $gform_confirmation_wrapper = quick_contact.$component.find('.gform_confirmation_wrapper');
        $gform_confirmation_wrapper.attr('tabindex', '0');
        quick_contact.$toggle.hide();
        window.setTimeout(function () {
          $gform_confirmation_wrapper.focus();
          window.setTimeout(function () {
            return quick_contact.$component.remove();
          }, 3000);
        }, 0);
      }
    });
  })();

  $(window).bind('load resize', function (e) {
    var t = $('.tabs-wrp > ul > li.active'),
        tabWidth = t.width();
    t.parents('.tabs-wrp').find('.triangle').css('right', tabWidth / 2 - 35 + t.index() * tabWidth);
  });
  ;

  (function () {
    $('.tabs-wrp > ul > li').on('click', function () {
      var t = $(this),
          tabWidth = t.width();
      setTimeout(function () {
        t.parents('.tabs-wrp').find('.triangle').css('right', tabWidth / 2 - 35 + t.index() * tabWidth);
      }, 0);
    });
  })();
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    var $modal_member = $('.modal--member'); // 	Occurs when the modal is about to be shown

    $modal_member.on('show.bs.modal', function () {
      var id = $(this).attr('id');
      var $toggle = $("[href=\"#".concat(id, "\"]"));
      $toggle.addClass('js-open');
    }); // Occurs when the modal is about to be hidden

    $modal_member.on('hide.bs.modal', function () {
      var id = $(this).attr('id');
      var $toggle = $("[href=\"#".concat(id, "\"]"));
      $toggle.removeClass('js-open');
    });
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var section = urlParams.get('section');

    if (section === "contact") {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".license_mail").offset().top
      }, 2000);
    }
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  jQuery(document).ready(function ($) {
    $('.quick-checking-toggle').on('click', function (e) {
      e.preventDefault();
      var $toggle = $(this);
      var quick_checking_default = $("#quick_checking");
      var quick_checking = $toggle.data('quick-checking') || $toggle.attr('href');
      quick_checking = quick_checking ? $("".concat(quick_checking)) : quick_checking_default;

      if (quick_checking.length) {
        var site_overlay = window.site_overlay;
        quick_checking.toggleClass('open');
        quick_checking.hasClass('open') ? site_overlay.open() : site_overlay.close() && quick_checking.find('.active').removeClass('active');
      }
    });
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  jQuery(document).ready(function ($) {
    function Tabs(showcase) {
      this.$ = showcase.find('.showcase-tabs');
      this.ACTIVE_KEY = 'animation-active';
    }

    ;

    Tabs.prototype.disable_events = function () {
      this.$.addClass(this.ACTIVE_KEY);
    };

    Tabs.prototype.enable_events = function () {
      this.$.removeClass(this.ACTIVE_KEY);
    };

    function Video($video) {
      this.$ = $video;
    }

    ;

    Video.prototype.get_node = function () {
      return this.$.get(0);
    }; // Set up timeout so we can know when to close the current video and return to the regular behavior


    Video.prototype.get_timeout = function () {
      return (window.parseFloat(this.get_node().duration) - 1) * 1000;
    };

    Video.prototype.play = function () {
      this.get_node().play();
    };

    Video.prototype.pause = function (currentTime) {
      var video_node = this.get_node();
      video_node.pause();
      if (currentTime > -1) video_node.currentTime = currentTime;
    };

    function App($) {
      this.$ = $;
      this.button_toggles = this.$.find('.showcase-pane__button');
      var current_animation_timeout = null;

      this.set_current_animation_timeout = function (animation_timeout) {
        current_animation_timeout = animation_timeout;
      };

      this.clear_current_animation_timeout = function () {
        current_animation_timeout && window.clearTimeout(current_animation_timeout);
        current_animation_timeout = null;
      };
    }

    App.prototype.is_mobile_view = function () {
      return window.innerWidth <= 767;
    };

    App.prototype.get_current_view_key = function () {
      return this.is_mobile_view() ? 'mobile' : 'desktop';
    };

    App.prototype.get_sphere = function () {
      var $sphere = this.$.find("video.showcase-app__video-bg--".concat(this.get_current_view_key())).first();
      return new Video($sphere);
    };

    var showcase = $('.home .showcase');
    var app = new App(showcase.find('.showcase-app').first());
    var tabs = new Tabs(showcase);
    var hide = {
      opacity: 0
    };
    var show = {
      opacity: 1
    };
    tabs.$.find('a').on('hide.bs.tab', function (event) {
      var $active_pill = $(event.target); // active tab

      var $previous_pill = $(event.relatedTarget); // previous tab

      var $active_tab = $($active_pill.attr('href'));
      var $previous_tab = $($previous_pill.attr('href'));
      var $active_button = $active_tab.find('.showcase-pane__button');
      var $previous_button = $previous_tab.find('.showcase-pane__button');
      var sphere = app.get_sphere();
      var view_key = app.get_current_view_key();
      app.clear_current_animation_timeout();
      var $previous_video = new Video($previous_button.parent().find("video.showcase-pane__animation-video--".concat(view_key)));
      $previous_video.$.css(hide);
      $previous_video.pause(0);
      sphere.$.css(show);
      $previous_button.show().removeClass('active').find('.-pre-ripple').remove();
    });
    app.button_toggles.on('click', function (e) {
      var $button = $(this);
      var view_key = app.get_current_view_key();
      var sphere = app.get_sphere();
      var video = new Video($button.parent().find("video.showcase-pane__animation-video--".concat(view_key))); // Adding specific transition properties to the Ripple animation

      $button.addClass('active'); // Adding Ripple

      window.createRipple.call(this, e); // Animat to all video background to give the user a sense of action

      sphere.$.animate(hide, {
        duration: 0,
        complete: function complete() {
          // Play the current video animation
          video.play(); // Will setup animation on the current video

          video.$.animate(show, {
            duration: 1000
          });
          var current_animation = window.setTimeout(function () {
            var complete = function complete() {
              video.pause(0);
              sphere.$.animate(show, {
                duration: 1000,
                complete: function complete() {
                  return $button.find('.-pre-ripple').remove();
                }
              });
              $button.hide().removeClass('active').fadeIn(1000);
            };

            video.$.animate(hide, {
              complete: complete,
              duration: 400
            });
          }, video.get_timeout());
          app.set_current_animation_timeout(current_animation);
        }
      });
    });
  });
})(window, document, jQuery);
jQuery(document).ready(function ($) {
  var $body = $('body');
  var $site_navbar = $('#site_navbar');
  var navbar_menu = new Comp_Factory($site_navbar, '-pre-menu--open');

  var close_if_clicked_outside = function close_if_clicked_outside(cb) {
    var menu = this; // Close menu if clicked outside of the menu container

    $(document).mouseup(function (e) {
      if (!menu.is(e.target) // if the target of the click isn't the container...
      && menu.has(e.target).length === 0 // ... nor a descendant of the container
      && e.which === 1) {
        cb && cb(e);
      }
    });
  };

  getTop() > 0 && $body.addClass('site-navbar-scroll');
  $site_navbar.addClass('-pre-site-navbar--init');

  var handle_navbar_scroll = function handle_navbar_scroll(event) {
    if (getTop() === 0) $body.removeClass('site-navbar-scroll');else $body.addClass('site-navbar-scroll');
  };

  $(window).on('scroll', handle_navbar_scroll);
  ;

  (function () {
    var $navbar_hamburger = $('.hamburger-toggle');
    var keyframes = {
      opacity: 0,
      visibility: 'hidden'
    };

    var open_menu = function open_menu(e) {
      e.preventDefault();
      navbar_menu.toggle();
      $navbar_hamburger.animate(keyframes, 100, function () {
        var opacity = keyframes.opacity,
            visibility = keyframes.visibility;
        var ACTIVE_CLASS = 'hamburger-toggle--active';
        navbar_menu.is_open() ? $navbar_hamburger.addClass(ACTIVE_CLASS) : $navbar_hamburger.removeClass(ACTIVE_CLASS);
        $navbar_hamburger.animate({
          opacity: 1,
          visibility: 'visible'
        }, 250);
      });

      if (navbar_menu.is_open()) {
        window.site_overlay.open();
        return;
      }

      window.site_overlay.close();
    };

    $navbar_hamburger.on('click', open_menu);

    var clicked_outside = function clicked_outside(e) {
      var $target_element = $(e.target);

      if (navbar_menu.is_open() && $target_element.closest('.site-navbar__hamburger').length === 0) {
        var event = jQuery.Event('click', {
          keyCode: 1
        });
        $navbar_hamburger.trigger(event);
      }
    }; //$('body').on('click', '#site_overlay.-pre-overlay--in', clicked_outside );
    //close_if_clicked_outside.call( $('#menu-primary').parent(), clicked_outside );

  })();
});
;

(function (window, document, $) {
  "use strict";

  jQuery(document).ready(function () {
    return window.site_overlay = new Comp_Factory($('#site_overlay'), '-pre-overlay--in');
  });
})(window, document, jQuery);
(function (window, document, $) {
  "use strict";

  jQuery(document).ready(function ($) {
    var defaults = {
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      focusOnSelect: true,
      infinite: true,
      arrows: false,
      autoplay: false,
      rtl: unlimited_is_rtl(),
      fade: false,
      cssEase: "linear"
    };
    var breakpoint = {
      sm: 768,
      md: 992,
      lg: 1200,
      xl: 1600
    };

    var setBreakpoint = function setBreakpoint(breakpoint, settings) {
      --breakpoint;
      return {
        breakpoint: breakpoint,
        settings: settings
      };
    };

    var unslick = function unslick(breakpoint) {
      return setBreakpoint(breakpoint, "unslick");
    };

    var setSlick = function setSlick(selector, _ref) {
      var defaults = _ref.defaults,
          options = _ref.options;
      return $(selector).slick($.extend({}, defaults, options));
    };

    {
      var options = {
        centerPadding: "30px",
        slide: ".updates-grid__item",
        centerMode: true,
        responsive: [unslick(breakpoint.sm)]
      };
      setSlick(".updates:not(.updates--simple) .updates-grid", {
        defaults: defaults,
        options: options
      });
    }
    {
      var _options = {
        slide: ".packages-intro-grid__item",
        dots: true,
        responsive: [unslick(breakpoint.sm)]
      };
      setSlick(".packages-intro-grid", {
        defaults: defaults,
        options: _options
      });
    }
    {
      var _options2 = {
        slide: ".our-partners-grid__item",
        centerMode: true,
        slidesToShow: 2,
        responsive: [{
          breakpoint: 768,
          settings: {
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            slidesToShow: 6
          }
        }] // responsive: [unslick(breakpoint.sm)]

      };
      setSlick(".our-partners-grid", {
        defaults: defaults,
        options: _options2
      }); // .slick('slickGoTo', 1)
    }
    {
      var _options3 = {
        slide: ".testimonials-grid__item",
        centerMode: true,
        slidesToShow: 1,
        responsive: [unslick(breakpoint.sm)]
      };
      setSlick(".testimonials-grid", {
        defaults: defaults,
        options: _options3
      });
    }
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  jQuery(document).ready(function ($) {
    var $wizard_app = $('.wizard-app');
    var $pills = $wizard_app.find('.wizard-pills');
    var $tab_content = $wizard_app.find('.tab-content');
    var $answers = $wizard_app.find('.wizard-question__answers');
    var $packages = $wizard_app.find('.wizard-tab-pane__packages-package');
    var wizard_score = 0;
    $answers.find('a').on('click', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $tab_pane = {
        el: $this.closest('.wizard-tab-pan')
      };
      $tab_pane.id = $tab_pane.el.attr('id');

      if (!$this.parent().index()) {
        wizard_score += 1;
      }

      var next_tab = $($pills.find('li.active').next().find('a'));
      $packages.hide();
      next_tab.tab('show');
    }); // Occurs when the tab is fully shown (after CSS transitions have completed)

    $pills.find('a').on('shown.bs.tab', function (event) {
      var $active_tab = $($(event.target).get(0).hash); // active tab

      var $title = $active_tab.find('.wizard-question__question');

      if ($title.length) {//$title.attr('tabindex', '0');
        //window.setTimeout(() => $title.focus(), 0 );
      }

      $wizard_app.find("[data-wizard_package_score=\"".concat(wizard_score, "\"]")).fadeIn(400, function () {//window.setTimeout(() => $(this).focus(), 0 );
      });
    });
  });
})(window, document, jQuery);